export type PaletteItem = { type: "session" | "idea"; key: string; label: string };

/** ⌘K quick-jump overlay: filter sessions/ideas and activate one (Enter picks the top match). */
export function CommandPalette({
  query,
  setQuery,
  items,
  onActivate,
  onClose,
}: {
  query: string;
  setQuery: (q: string) => void;
  items: PaletteItem[];
  onActivate: (item: PaletteItem) => void;
  onClose: () => void;
}) {
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="palette" onClick={(e) => e.stopPropagation()}>
        <input
          autoFocus
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && items[0]) onActivate(items[0]);
          }}
          placeholder="Jump to a session or idea…"
        />
        <div className="palette-list">
          {items.length === 0 ? (
            <div className="palette-empty">No matches</div>
          ) : (
            items.slice(0, 12).map((it) => (
              <button key={`${it.type}-${it.key}`} className="palette-item" onClick={() => onActivate(it)}>
                <span className="palette-type">{it.type === "idea" ? "Idea" : "Session"}</span>
                <span className="palette-label">{it.label}</span>
              </button>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
